import styled from 'styled-components';

export const SizeModal = styled('div')`
  ${({ theme, sizeScreen }) => `
        display: flex;
        justify-content: center;
        width: ${theme.spacing.full};
        padding-bottom: ${theme.spacing.px20};
        ${
          sizeScreen === 'small'
            ? `.rdrDefinedRangesWrapper {
                    display: none;
                }
                .rdrCalendarWrapper{
                    font-size: 60%;
                } `
            : ''
        }
    `}
`;

export const WidthModal = styled('div')`
  ${({ hideStaticRanges }) => `
        display: inline-block;
        ${
          hideStaticRanges &&
          `.rdrDefinedRangesWrapper {
                display: none;
            }`
        }
    `}
`;
